import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import React, { useState } from "react";
import { Item } from "../../utils/sharedTypes";
import ModulesOptionsBar from "./ModulesOptionsBar";
import ModulesTable from "./ModulesTable";

interface Props {
  dialogOpen: boolean;
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ModulesManagementDialog = ({ dialogOpen, setDialogOpen }: Props) => {
  const [selectedModules, setSelectedModules] = useState<Item[]>([]);
  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={dialogOpen}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle>Manage Modules</DialogTitle>
      <DialogContent>
        <ModulesTable setSelectedModules={setSelectedModules} />
        <ModulesOptionsBar
          selectedModules={selectedModules}
          setSelectedModules={setSelectedModules}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setDialogOpen(false);
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModulesManagementDialog;
